import { formatThoughtForSecondsLabel } from '@/services/chatApi'
import { detectGeneratedArtifactKind } from './generatedArtifactAssistantPayloadBody.js'
import { resolveGeneratedArtifactDetails } from './generatedArtifactAssistantPayloadResolve.js'
import { buildGeneratedArtifactAssistantBlocks } from './generatedArtifactAssistantPayloadBlocks.js'

/**
 * @param {string} trimmed
 * @param {number} thinkingStartedAtMs
 * @returns {{ patch: Record<string, unknown>, artifactId: string }}
 */
export function buildGeneratedArtifactAssistantMessagePatch(trimmed, thinkingStartedAtMs) {
  const kind = detectGeneratedArtifactKind(trimmed)
  if (!kind) {
    throw new Error('buildGeneratedArtifactAssistantMessagePatch: not a generated artifact prompt')
  }
  const details = resolveGeneratedArtifactDetails(trimmed, kind)
  const { blocks, artifactId } = buildGeneratedArtifactAssistantBlocks(details)
  const endedAt = Date.now()
  return {
    artifactId,
    patch: {
      text: '',
      blocks,
      agentBrand: 'SIA',
      agentName: 'Master Root Agent',
      thoughtSummary: formatThoughtForSecondsLabel(thinkingStartedAtMs, endedAt),
      createdAt: endedAt,
    },
  }
}
